var map = {
	"./AmountPayable.svg": "84d8",
	"./CreditStatement.svg": "a56a",
	"./Dashboard.svg": "1aa3",
	"./Group 10.svg": "b82e",
	"./Group 100.svg": "67b1",
	"./Group 106.svg": "ab3e",
	"./Group 107(2).svg": "3147",
	"./Group 107(3).svg": "95e3",
	"./Group 83.svg": "ecaa",
	"./Group(11).svg": "0fc5",
	"./LoanOffers.svg": "78b5",
	"./MyCards.svg": "cac4",
	"./MyProfile.svg": "aa89",
	"./PaymentHistory.svg": "2fb7",
	"./ReferAndEarn.svg": "fecd",
	"./RewardStatement.svg": "74f9",
	"./account-expired-icon.svg": "7cfb",
	"./accountblock-Rupee-Icon.svg": "5bbe",
	"./add-supplier-icon.svg": "baa7",
	"./addGst.svg": "1ff5",
	"./application-rejected.svg": "c173",
	"./applicationEpaylater.svg": "39b2",
	"./back.svg": "ccfe",
	"./background-pattern.svg": "2f29",
	"./business-doc-image.svg": "5e7d",
	"./bussiness-details.svg": "2510",
	"./buy-mobile.svg": "995c",
	"./buy.svg": "f3f6",
	"./calendar-icon.svg": "0780",
	"./calendar_icon_new.svg": "ac03",
	"./card-green.svg": "b6a8",
	"./card.svg": "2579",
	"./catalog.svg": "b839",
	"./check-white.svg": "93ed",
	"./closed-eye.svg": "555e",
	"./copy-icon-alternative.svg": "7417",
	"./copy-icon.svg": "ce6d",
	"./credit-icon-1.svg": "07ec",
	"./credit-icon-2.svg": "3414",
	"./credit-icon-3.svg": "4b71",
	"./credit-mobile.svg": "2fbf",
	"./credit.svg": "b72e",
	"./creditcard.svg": "d607",
	"./cross-error-red.svg": "f118",
	"./cross-error-shop.svg": "8b56",
	"./cross-light.svg": "a31f",
	"./cross-primary.svg": "f880",
	"./cross.svg": "89fe",
	"./cvv-icon.svg": "d0f0",
	"./dashboard-active.svg": "3493",
	"./dashboard-mob.svg": "22c8",
	"./date-icon.svg": "1b3d",
	"./debit-card-pg.svg": "af1a",
	"./debitcard.svg": "81ac",
	"./default-bank-icon.svg": "835a",
	"./discount-badge.svg": "d680",
	"./doc.svg": "6700",
	"./document_sign.svg": "aa64",
	"./documents-illustration.svg": "f659",
	"./double-bank-statement.svg": "e7e1",
	"./down-arrow.svg": "8c3e",
	"./down-butterfly.svg": "d7e7",
	"./download-icon.svg": "e3cc",
	"./downloadStatement.svg": "402d",
	"./dropdown-button.svg": "e8a9",
	"./female.svg": "c856",
	"./flipkart-icon.svg": "5d4c",
	"./gPay-Email.svg": "39e4",
	"./gPay-Gmail.svg": "25b5",
	"./gPay-Invite-Active.svg": "329b",
	"./gPay-Invite.svg": "819a",
	"./gPay-Payment-Active.svg": "f3f5",
	"./gPay-Payment.svg": "4f8e",
	"./gPay-Phone.svg": "28b8",
	"./gPay-Share.svg": "405d",
	"./gPay-Sms.svg": "6762",
	"./gPay-Supplier-Active.svg": "f0f5",
	"./gPay-Supplier.svg": "b1d9",
	"./gPay-Support-Active.svg": "f4ea",
	"./gPay-Support.svg": "19f5",
	"./gPay-WhatApp.svg": "acde",
	"./gPay-pdf.svg": "3211",
	"./gPayPending.svg": "bcd9",
	"./google-play.svg": "1457",
	"./gray-down-arrow.svg": "0992",
	"./gray-search.svg": "a150",
	"./gray-up-arrow.svg": "ef39",
	"./illustration-name.svg": "1fcd",
	"./image-dummy.svg": "699e",
	"./info-blue-icon.svg": "a583",
	"./info-icon.svg": "5d19",
	"./input-search.svg": "093f",
	"./insta-download.svg": "4061",
	"./kyc.svg": "9219",
	"./left-arrow-back.svg": "de06",
	"./loan-agreement-icon.svg": "e429",
	"./loan-failure.svg": "1251",
	"./loan-offers-icon.svg": "5f3d",
	"./lock.svg": "3c1a",
	"./logo-primary.svg": "718f",
	"./logo-product-bnpl.svg": "6b2d",
	"./logo-product-edi.svg": "f4b2",
	"./lots-icon.svg": "a9ec",
	"./male.svg": "c04b",
	"./mandate-failure.svg": "e92e",
	"./map-marker-1.svg": "921e",
	"./marketplace-illustration.svg": "5a35",
	"./meter.svg": "9fa4",
	"./my-suppliers-icon.svg": "4832",
	"./needle.svg": "b168",
	"./net-banking-pg.svg": "4ba8",
	"./netbanking.svg": "4f90",
	"./no-bank-statement.svg": "56e9",
	"./notificationBell.svg": "439a",
	"./offer-icon.svg": "3225",
	"./offers-active.svg": "22ab",
	"./offers.svg": "da68",
	"./orange-tick.svg": "58f5",
	"./others-pg.svg": "c3b6",
	"./payment-history.svg": "d903",
	"./pdf-icon.svg": "1c72",
	"./pending-payments.svg": "d81f",
	"./pending-requests-icon.svg": "b895",
	"./pending.svg": "e211",
	"./personal-details.svg": "3dea",
	"./pluse-shop-icon.svg": "0a09",
	"./primary-arrow-in-circle.svg": "c6a0",
	"./primary-arrow.svg": "80b4",
	"./primary-down-arrow.svg": "18f7",
	"./primary-left-arrow.svg": "e6b3",
	"./procure-supplies-icon.svg": "8a04",
	"./quick-payment.svg": "0a61",
	"./radio-check.svg": "e92c",
	"./rewards-active.svg": "dd60",
	"./rewards.svg": "d3fd",
	"./right-arrow-payment.svg": "dcfe",
	"./right-arrow-primary.svg": "a1f4",
	"./right-arrow.svg": "f590",
	"./right-down-butterfly.svg": "6cec",
	"./rupeeIcon.svg": "0f30",
	"./search-Icon.svg": "0971",
	"./sell-mobile.svg": "8a3e",
	"./sell.svg": "46d3",
	"./statement-active.svg": "e694",
	"./statement.svg": "72ca",
	"./success-green.svg": "82d4",
	"./success.svg": "2764",
	"./sucessTick.svg": "c733",
	"./supplier-icon.svg": "1d38",
	"./supplier-logo.svg": "6d4b",
	"./suppliers-active.svg": "56df",
	"./suppliers.svg": "84b9",
	"./time-icon.svg": "8611",
	"./trust-icon.svg": "40ae",
	"./udyam-verification.svg": "58dd",
	"./under-review-2.svg": "3f96",
	"./unilever-icon.svg": "8271",
	"./up-butterfly.svg": "99b2",
	"./upi-autopay.svg": "b7b5",
	"./upi-pg.svg": "7d82",
	"./upi.svg": "0cf3",
	"./upload-failed.svg": "9b47",
	"./upload-manually.svg": "7c7a",
	"./upload-static-icon.svg": "2c0f",
	"./v-kyc-icon.svg": "6eb0",
	"./wallet.svg": "bc38",
	"./whatsapp.svg": "3357",
	"./zokudu-card-background.svg": "dd94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";